"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxConfigDeletedContract = exports.TaxConfigUpdatedContract = exports.TaxConfigCreatedContract = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const events_1 = require("@getgreenline/events");
const TaxModels_1 = require("./TaxModels");
const customers_1 = require("@getgreenline/customers");
class TaxConfigEventDataContract {
}
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)()
], TaxConfigEventDataContract.prototype, "companyId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)()
], TaxConfigEventDataContract.prototype, "name", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)()
], TaxConfigEventDataContract.prototype, "displayName", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)()
], TaxConfigEventDataContract.prototype, "isActive", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)()
], TaxConfigEventDataContract.prototype, "rateType", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)()
], TaxConfigEventDataContract.prototype, "rateAmount", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsEnum)(TaxModels_1.TaxType),
    (0, class_validator_1.IsOptional)()
], TaxConfigEventDataContract.prototype, "taxType", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.IsDefined)()
], TaxConfigEventDataContract.prototype, "categoryIds", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsInt)({ each: true }),
    (0, class_validator_1.IsDefined)()
], TaxConfigEventDataContract.prototype, "locationIds", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsEnum)(customers_1.IdType, { each: true }),
    (0, class_validator_1.IsDefined)()
], TaxConfigEventDataContract.prototype, "exemptIdentityTypes", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsInt)({ each: true }),
    (0, class_validator_1.IsDefined)()
], TaxConfigEventDataContract.prototype, "compoundingTaxes", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsEnum)(TaxModels_1.TaxableFees, { each: true }),
    (0, class_validator_1.IsDefined)()
], TaxConfigEventDataContract.prototype, "taxableFees", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)()
], TaxConfigEventDataContract.prototype, "createdBy", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)()
], TaxConfigEventDataContract.prototype, "createDate", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)()
], TaxConfigEventDataContract.prototype, "updatedBy", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)()
], TaxConfigEventDataContract.prototype, "updateDate", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)()
], TaxConfigEventDataContract.prototype, "deleteDate", void 0);
class TaxConfigBaseContract extends events_1.EventsV3.EventModels.EventContractV3 {
    constructor(params) {
        super(params);
        this.data.attributes = events_1.GreenlineEvent.create(TaxConfigEventDataContract, params.attributes);
    }
}
class TaxConfigCreatedContract extends TaxConfigBaseContract {
    constructor(params) {
        super(params);
        this.data.attributes = events_1.GreenlineEvent.create(TaxConfigEventDataContract, params.attributes);
    }
}
exports.TaxConfigCreatedContract = TaxConfigCreatedContract;
class TaxConfigUpdatedContract extends TaxConfigBaseContract {
    constructor(params) {
        super(params);
        this.data.attributes = events_1.GreenlineEvent.create(TaxConfigEventDataContract, params.attributes);
    }
}
exports.TaxConfigUpdatedContract = TaxConfigUpdatedContract;
class TaxConfigDeletedContract extends TaxConfigBaseContract {
    constructor(params) {
        super(params);
        this.data.attributes = events_1.GreenlineEvent.create(TaxConfigEventDataContract, params.attributes);
    }
}
exports.TaxConfigDeletedContract = TaxConfigDeletedContract;
//# sourceMappingURL=Event.js.map